import * as proposalSelectors from '@makemydeal/dr-dash-store/selectors/proposalSelectors';
import { useSelector } from 'react-redux';
import { Toast } from '../../common/DataLoadingToast/Toast';
import { LoadingSection } from '@makemydeal/dr-shared-components';
import { copyToastMessages, deleteToastMessages, setPrimaryToastMessages, getToastMessage } from './constants';

const ProposalListAlert: React.FC = () => {
    const getProposalsError = useSelector(proposalSelectors.getProposalsError);
    const copyProposalError = useSelector(proposalSelectors.copyProposalError);
    const deleteProposalError = useSelector(proposalSelectors.deleteProposalError);
    const updateProposalError = useSelector(proposalSelectors.updateProposalError);

    const copyProposalSuccess = useSelector(proposalSelectors.copyProposalSuccess);
    const deleteProposalSuccess = useSelector(proposalSelectors.deleteProposalSuccess);
    const updateProposalSuccess = useSelector(proposalSelectors.updateProposalSuccess);

    const isCopyLoading = useSelector(proposalSelectors.copyProposalLoading);
    const isDeleteLoading = useSelector(proposalSelectors.deleteProposalLoading);
    const isSetPrimaryLoading = useSelector(proposalSelectors.updateProposalLoading);
    const isListLoading = useSelector(proposalSelectors.getProposalsLoading);

    const isLoading = isCopyLoading || isDeleteLoading || isSetPrimaryLoading;

    return (
        <>
            <LoadingSection loading={isLoading} />
            <Toast
                isLoading={isCopyLoading}
                isError={copyProposalError}
                isLoaded={copyProposalSuccess}
                getMessage={(type) => copyToastMessages[type]}
            />
            <Toast
                isLoading={isDeleteLoading}
                isError={deleteProposalError}
                isLoaded={deleteProposalSuccess}
                getMessage={(type) => deleteToastMessages[type]}
            />
            <Toast
                isLoading={isSetPrimaryLoading}
                isError={updateProposalError}
                isLoaded={updateProposalSuccess}
                getMessage={(type) => setPrimaryToastMessages[type]}
            />
            <Toast
                isLoading={isListLoading}
                isError={getProposalsError}
                isLoaded={false}
                getMessage={(type) => getToastMessage[type]}
            />
        </>
    );
};

export default ProposalListAlert;
